import { render, staticRenderFns } from "./recommender.vue?vue&type=template&id=332bf157&scoped=true"
import script from "./recommender.vue?vue&type=script&lang=js"
export * from "./recommender.vue?vue&type=script&lang=js"
import style0 from "./recommender.vue?vue&type=style&index=0&id=332bf157&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332bf157",
  null
  
)

export default component.exports